// Translated by Park Seok Ho

import login from './login';

export default {
  language: 'ko',
  country: 'kr',
  name: '한국어',
  embeddedLocale: login,
  flags: ['KR'],
};
